import { historySVC } from "app/history/service"
import { APP_CONTEXTS, IRootState } from "app/model"
import { getStore } from "app/store/store"
import { CAMPAIGN_STATUSES } from "campaign/model"
import { formEventModule } from "form/event"
import { formActionCreator } from "form/store/actions"
import { CAMPAIGN_TAB_ID_QUERY_PARAM } from "page/model"
import { FORM_EVENTS, FORM_TABS, IAppForm, IForm, IFormGeoTargets, IFormRelations } from "../model"

export function getAppForm(state?: IRootState): IAppForm {
  if (!state) {
    state = getStore().getState()
  }
  const context = state.app.activeContext
  if (context === null) {
    throw Error("No context is active")
  }
  switch (context) {
    case APP_CONTEXTS.CAMPAIGN_CREATE: {
      return state.form.campaignCreateForm
    }
    case APP_CONTEXTS.CAMPAIGN_EDIT: {
      return state.form.campaignEditForm
    }
    case APP_CONTEXTS.FORECAST_CREATE: {
      return state.form.forecastCreateForm
    }
    case APP_CONTEXTS.FORECAST_EDIT: {
      return state.form.forecastEditForm
    }
    case APP_CONTEXTS.DSP_DEAL_CREATE: {
      return state.form.dspDealCreateForm
    }
    case APP_CONTEXTS.DSP_DEAL_EDIT: {
      return state.form.dspDealEditForm
    }
  }
}

export function getForm(state?: IRootState): IForm {
  if (!state) {
    state = getStore().getState()
  }
  return getAppForm(state).form
}

export function setFormRelations(relations: Partial<IFormRelations>): void {
  const state = getStore().getState()
  const context = state.app.activeContext
  if (context === null) {
    throw Error("No context is active")
  }
  getStore().dispatch(formActionCreator.setRelations(context, relations))
}

export function setFormGeoTargets(geoTargets: Partial<IFormGeoTargets>): void {
  const state = getStore().getState()
  const context = state.app.activeContext
  if (context === null) {
    throw Error("No context is active")
  }
  getStore().dispatch(formActionCreator.setFormGeoTargets(context, geoTargets))
}

export function activateFormTab(toActivateTab: FORM_TABS, noHistory?: boolean): void {
  const form = getForm()
  if (toActivateTab === form.activeTab) {
    return
  }
  if (!noHistory) {
    historySVC.pushHashParameters(CAMPAIGN_TAB_ID_QUERY_PARAM, toActivateTab)
  }
  getStore().dispatch(formActionCreator.setActiveTab(form.context.appContext, toActivateTab))
}

export function isCreateForm(form: IForm): boolean {
  return form.statusId === CAMPAIGN_STATUSES.TEMPORARY
}

export function notifyFormOpened(form: IForm): void {
  formEventModule.notify(FORM_EVENTS.FORM_OPENED, form)
}

export function notifyFormClosed(form: IForm): void {
  formEventModule.notify(FORM_EVENTS.FORM_CLOSED, form)
}

export function notifySummaryOpened(form: IForm): void {
  formEventModule.notify(FORM_EVENTS.SUMMARY_OPENED, form)
}

export function notifySummaryClosed(form: IForm): void {
  formEventModule.notify(FORM_EVENTS.SUMMARY_CLOSED, form)
}

export function resetForm(appContext: APP_CONTEXTS): void {
  getStore().dispatch(formActionCreator.clearAppForm(appContext))
}

export function setIsPausedInForm(form: IForm, isPaused: boolean): void {
  getStore().dispatch(
    formActionCreator.setForm({
      form: {
        ...form,
        context: {
          ...form.context,
          isPaused
        }
      }
    })
  )
}
